import Animated, {
  useAnimatedStyle,
  withTiming,
} from "react-native-reanimated";

import { VnBox } from "@/components/VnBox";
import { OnboardingFooterToneType } from "@/domain/onboarding";
import { cn } from "@/utils/tailwind";

type OnboardingPaginationPropsType = {
  stepCount: number;
  currentStep: number;
  tone: OnboardingFooterToneType;
};

const ANIMATION_DURATION = 300;

const Dot = ({
  isActive,
  tone,
}: {
  isActive: boolean;
  tone: OnboardingFooterToneType;
}) => {
  const animatedStyle = useAnimatedStyle(() => ({
    width: withTiming(isActive ? 30 : 9, { duration: ANIMATION_DURATION }),
  }));

  return (
    <Animated.View style={animatedStyle}>
      <VnBox
        className={cn("h-[9px] rounded-full", {
          "bg-card border-foreground/10 border": isActive && tone === "light",
          "bg-foreground/10": !isActive && tone === "light",
          "bg-white": isActive && tone === "dark",
          "bg-white/40": !isActive && tone === "dark",
        })}
      />
    </Animated.View>
  );
};

export const OnboardingPagination = ({
  stepCount,
  currentStep,
  tone,
}: OnboardingPaginationPropsType) => {
  return (
    <VnBox className="flex-row items-center justify-center gap-1">
      {Array.from({ length: stepCount }, (_, index) => (
        <Dot key={index} isActive={currentStep === index + 1} tone={tone} />
      ))}
    </VnBox>
  );
};
